<template>
    <div class="card-user">
        <div class="card-user__content">
            <div class="card-user__header">
                <div class="card-user__avatar">
                    <img :src="user.avatar" v-if="user.avatar" />
                    <svg
                        width="56"
                        height="56"
                        viewBox="0 0 56 56"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="card-user__avatar-empty"
                        v-else
                    >
                        <rect width="56" height="56" rx="16" fill="#EBF0F5" />
                        <path
                            d="M13 41.3333C16.893 37.2043 22.1784 34.6667 28 34.6667C33.8216 34.6667 39.107 37.2043 43 41.3333M35.5 20.5C35.5 24.6421 32.1421 28 28 28C23.8579 28 20.5 24.6421 20.5 20.5C20.5 16.3579 23.8579 13 28 13C32.1421 13 35.5 16.3579 35.5 20.5Z"
                            stroke="#B5C1DD"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
                <div class="card-user__scores">
                    <div class="card-user__total-scores">
                        <IconStarCircle class="card-user__total-scores-icon" />
                        {{ user.ratingPosition || '-' }}
                    </div>
                    <div class="card-user__position">в рейтинге</div>
                </div>
            </div>
            <div class="card-user__name">{{ user.surname || '&nbsp;' }} {{ user.name || '&nbsp;' }}</div>
            <div class="card-user__region">{{ user.address.data.region_with_type || ' ' }}</div>
            <div class="card-user__total-coins">
                <div class="card-user__total-coins-text" @click="isShowHistory = true">
                    <IconCoins />
                    <div>{{ spaceInNumber(user.totalCoins || 0) }}</div>
                    <IconClock />
                </div>
                <!-- Временно: маркет -->
                <!-- <a href="https://market.rsv.ru" class="card-user__total-coins-link">Потратить</a> -->
            </div>
        </div>
        <footer class="card-user__footer">
            <a href="#" class="card-user__link" @click="isShowHowGetCoins = true"> Как получить баллы РСВ? </a>
        </footer>
        <Dialog v-model="isShowHistory" overClose class="card-user__dialog">
            <HistoryCoinsDialog />
        </Dialog>
        <Dialog v-model="isShowHowGetCoins" overClose class="card-user__dialog">
            <HowGetCoinsDialog />
        </Dialog>
    </div>
</template>

<script>
import IconCoins from '@/components/ratings/svg/IconCoins.vue';
import IconStarCircle from '@/components/ratings/svg/IconStarCircle.vue';
import HistoryCoinsDialog from './HistoryCoinsDialog.vue';
import HowGetCoinsDialog from './HowGetCoinsDialog.vue';
import Dialog from '../UI/Dialog';
import spaceInNumber from '@/tools/spaceInNumber';
import IconClock from './svg/IconClock.vue';

export default {
    name: 'CardUser',
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    components: { IconCoins, HistoryCoinsDialog, HowGetCoinsDialog, Dialog, IconClock, IconStarCircle },
    data() {
        return {
            isShowHistory: false,
            isShowHowGetCoins: false,
        };
    },
    methods: {
        spaceInNumber: spaceInNumber,
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';

.card-user {
    min-height: mrem(266);
    border-radius: mrem(16);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: mrem(16);
    background: #f7f8fa;

    * {
        font-family: 'Montserrat', sans-serif;
    }

    @include on-desktop {
        width: rem(440);
        border-radius: rem(16);
        min-height: 0;
    }

    &__content {
        padding: mrem(16);
        width: 100%;

        @include on-desktop {
            padding: rem(20);
        }
    }

    &__header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: mrem(16);
        width: 100%;

        @include on-desktop {
            align-items: flex-start;
            gap: rem(16);
        }
    }

    &__avatar-empty {
        width: mrem(60);
        height: mrem(60);
        border-radius: mrem(16);

        @include on-desktop {
            width: rem(112);
            height: rem(112);
            border-radius: rem(16);
        }
    }

    &__scores {
        display: flex;
        align-items: center;
        gap: mrem(8);

        margin-left: auto;

        @include on-desktop {
            gap: rem(8);
            padding-top: rem(5);
        }
    }

    &__total-scores-icon {
        width: mrem(20);
        height: mrem(20);

        @include on-desktop {
            width: rem(20);
            height: rem(20);
        }
    }

    &__total-scores {
        display: flex;
        align-items: center;
        gap: mrem(10);

        font-family: 'Montserrat', sans-serif;
        font-weight: 700;
        font-size: mrem(16);

        line-height: mrem(24);
        text-align: center;
        color: #2a2626;

        @include on-desktop {
            gap: rem(10);
            font-size: rem(16);
            line-height: rem(24);
            text-align: right;
            justify-content: flex-end;
        }
    }

    &__position {
        font-size: mrem(16);
        line-height: mrem(24);
        font-weight: 500;
        color: #2a2626;

        @include on-desktop {
            font-size: rem(16);
            line-height: rem(24);
        }
    }

    &__avatar {
        width: mrem(60);
        height: mrem(60);
        border-radius: mrem(16);

        img {
            width: 100%;
            height: 100%;
            border-radius: mrem(16);
        }

        @include on-desktop {
            width: rem(112);
            height: rem(112);

            img {
                border-radius: rem(16);
            }
        }
    }

    &__name {
        font-family: 'Montserrat', sans-serif;
        font-weight: 700;
        font-size: mrem(16);
        line-height: mrem(22);
        color: #2a2626;
        margin-top: mrem(20);
        margin-bottom: mrem(10);

        @include on-desktop {
            font-size: rem(18);
            line-height: rem(26);
            margin-top: rem(20);
            margin-bottom: rem(10);
        }
    }

    &__region {
        font-family: 'Montserrat', sans-serif;
        font-weight: 500;
        font-size: mrem(14);
        line-height: mrem(20);
        color: #000;
        margin-bottom: mrem(20);

        @include on-desktop {
            font-size: rem(16);
            line-height: rem(24);
            margin-bottom: rem(20);
        }
    }

    &__footer {
        padding: mrem(10) mrem(16);
        background: #f0f0f6;
        display: flex;
        justify-content: center;
        width: 100%;
        margin-top: auto;
        border-bottom-left-radius: mrem(16);
        border-bottom-right-radius: mrem(16);

        @include on-desktop {
            border-bottom-left-radius: rem(16);
            border-bottom-right-radius: rem(16);
            padding: rem(10) rem(16);
        }
    }

    &__link {
        font-family: 'Montserrat', sans-serif;
        font-weight: 600;
        font-size: mrem(14);
        line-height: mrem(20);
        text-decoration: underline;
        text-align: center;
        color: #69609f;
        cursor: pointer;

        display: flex;
        align-items: center;
        gap: mrem(6);

        svg {
            width: mrem(24);
            height: mrem(24);
        }

        @include on-desktop {
            font-size: rem(14);
            line-height: rem(24);

            gap: rem(6);

            svg {
                width: rem(24);
                height: rem(24);
            }
        }
    }

    &__total-coins-link {
        display: flex;
        justify-content: center;
        background: #db6c61;
        width: 100%;
        color: white;
        text-transform: uppercase;
        font-weight: 600;
        font-size: mrem(14);
        line-height: mrem(42);
        text-align: center;
        border-radius: mrem(10);

        @include on-desktop {
            font-size: rem(16);
            line-height: rem(48);

            border-radius: rem(10);

            padding: 0 rem(32);

            width: auto;
            margin-left: auto;
        }
    }

    &__total-coins {
        display: flex;
        flex-direction: column;
        gap: mrem(20);

        @include on-desktop {
            margin-top: auto;
            flex-direction: row;
        }
    }

    &__total-coins-text {
        display: flex;
        align-items: center;
        gap: mrem(8);
        font-family: 'Montserrat', sans-serif;
        font-weight: 700;
        font-size: mrem(14);
        line-height: mrem(20);
        color: #2a2626;
        cursor: pointer;

        div {
            flex-shrink: 0;
        }

        svg {
            width: mrem(24);
            height: mrem(24);
            flex-shrink: 0;
        }

        @include on-desktop {
            gap: rem(8);
            font-size: rem(16);
            line-height: rem(24);
            width: rem(200);

            svg {
                width: rem(24);
                height: rem(24);
                flex-shrink: 0;
            }
        }
    }

    &__dialog {
        padding: 0;
        z-index: 999999999999999999;

        ::v-deep div.dialog {
            width: 100vw;
            max-height: 100dvh;
            max-height: 100vh;
            height: 100vh;
            height: 100dvh;
            overflow: auto;
            border-radius: 0;

            @include on-desktop {
                width: rem(680);
                height: auto;
                max-height: rem(780);
                border-radius: rem(10);
                padding-right: rem(10) !important;
            }
        }
    }
}
</style>
